import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/vendor-info.module.scss';
import InfoItem from 'src/components/InfoItem';
import { IVendor } from 'src/types/vendor';
import { RouteComponentProps } from 'react-router';
import AdminLayout from 'src/components/layout/RoleLayout';
import RenderFile from 'src/components/RenderFile';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';

export interface StateProps {
    files: any;
    vendor: Partial<IVendor> | null;
}

export interface DispatchProps {
    getFiles: (id: string | number) => void;
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const VendorInfo: React.FunctionComponent<Props> = ({
    vendor,
    getData,
    getFiles,
    files,
    match: {
        params: { id },
    },
}: Props) => {
    useEffect(() => {
        if (id) {
            getFiles(id);
            getData(id);
        }
    }, [getData, getFiles, id]);

    if (!vendor) {
        return null;
    }
    const { email, name, phone, contact, address } = vendor;

    const previewFiles =
        files &&
        files.map((file: any, i: number) => (
            <li style={{ listStyleType: 'none' }} key={file.attach}>
                <a rel="noopener noreferrer" target="_blank" href={`${file.attach}`}>
                    <RenderFile file={file} />
                </a>
            </li>
        ));
    return (
        <AdminLayout>
            <Breadcrumbs
                items={[
                    { name: 'VENDORS', path: routes.VENDORS_LIST },
                    { name: `${name ? name : ''}`, path: '' },
                ]}
            />
            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.infoItems)}>
                    <InfoItem title={'Full Name:'} value={name} />
                    <InfoItem title={'Email:'} value={email ? email : ''} />
                    <InfoItem title={'Address:'} value={address ? address : ''} />
                    <InfoItem title={'Contact Person:'} value={contact ? contact : ''} />
                    <InfoItem title={'Phone Number:'} value={phone ? phone : ''} />
                    <InfoItem title={'Documents:'} value={previewFiles} />
                </div>

                <div>
                    <Link
                        className={classNames('btn', 'btn-outline-secondary')}
                        to={Router.generate(routes.VENDOR_EDIT, { id })}
                    >
                        EDIT
                    </Link>
                </div>
            </div>
        </AdminLayout>
    );
};

export default VendorInfo;
